const holidays = [
  {
    name: "Republlic Day",
    date: "2025-01-26",
    emoji: "🎆",
  },
  {
    name: "Independence Day",
    date: "2025-08-15",
    emoji: "🎆",
  },
  {
    name: "Vinayaka Chavithi",
    date: "2025-08-28",
    image: "data:image/jpeg;base64,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",
  },
  {
    name: "Vijaya Dashami & Mahatma Gandhi Jayanti",
    date: "2025-10-03",
    emoji: "🏹",
  },
  {
    name: "Deepavali",
    date: "2025-10-20",
    emoji: "🪔",
  },
  {
    name: "Christmas",
    date: "2025-12-25",
    emoji: "🎄",
  },
];


const HolidaysListing = () => {

  const today = new Date();
  const futureHolidays = holidays.filter(h => new Date(h.date) >= today);
  const nearestHoliday = futureHolidays.sort((a, b) => new Date(a.date) - new Date(b.date))[0];

  return (
    <div className="p-4 bg-green-50 min-h-screen">
      <h1 className="text-xl font-bold text-green-800 mb-4 text-center">📅 2025 Holiday List</h1>
      <div className="flex flex-col gap-4">
        {futureHolidays.map((holiday) => {
          const isNext = holiday.name === nearestHoliday.name;
          const dateObj = new Date(holiday.date);
          const options = { weekday: "long", month: "long", day: "numeric" };
          const formattedDate = dateObj.toLocaleDateString("en-IN", options);

          return (
            <div
              key={holiday.name}
              className={`bg-white rounded-xl shadow-md flex items-center p-4 gap-4 border-l-4 ${isNext ? "border-yellow-400 bg-yellow-50" : "border-green-500"
                }`}
            >
              <div className="w-14 h-14">
                {holiday.image ? (
                  <img
                    src={holiday.image}
                    alt={holiday.name}
                    className="w-full h-full object-cover rounded-full"
                  />
                ) : (
                  <div className="text-3xl pl-3">{holiday.emoji}</div>
                )}
              </div>
              <div>
                <h2 className="text-lg font-semibold text-green-700">{holiday.name}</h2>
                <p className="text-sm text-gray-600">{formattedDate}</p>
              </div>
            </div>
          );
        })}
      </div>

      {/* Message */}
      <div className="mt-8 text-center text-green-700 text-sm sm:text-base font-medium">
        “Take time to celebrate the people who make work feel less like work and more like family.”
        <br />Wishing you joyful holidays ahead!
      </div>
    </div>
  );
};

export default HolidaysListing;

// import React, { useState } from "react";
// import Calendar from "react-calendar";
// import { format } from "date-fns";
// import 'react-calendar/dist/Calendar.css'; // Required for layout, but styling will be overridden inline

// const holidays = [
//   { name: "Republic Day", date: "2025-01-26" },
//   { name: "Independence Day", date: "2025-08-15" },
//   { name: "Vinayaka Chavithi", date: "2025-08-30" },
//   { name: "Mahatma Gandhi Jayanti", date: "2025-10-02" },
//   { name: "Vijaya Dashami", date: "2025-10-03" },
//   { name: "Deepavali", date: "2025-10-20" },
//   { name: "Christmas", date: "2025-12-25" },
// ];

// const HolidaysListing = () => {
//   const [selectedDate, setSelectedDate] = useState(new Date());

//   const tileContent = ({ date, view }) => {
//     if (view === "month") {
//       const dateStr = format(date, "yyyy-MM-dd");
//       const holiday = holidays.find((h) => h.date === dateStr);
//       return holiday ? (
//         <p style={{ fontSize: '10px', color: 'red', marginTop: 4, textAlign: 'center' }}>
//           {holiday.name}
//         </p>
//       ) : null;
//     }
//   };

//   const dateStr = format(selectedDate, "yyyy-MM-dd");
//   const holiday = holidays.find((h) => h.date === dateStr);

//   return (
//     <div style={{
//       minHeight: '100vh',
//       backgroundColor: '#ecfdf5',
//       padding: '1rem',
//       display: 'flex',
//       flexDirection: 'column',
//       alignItems: 'center',
//     }}>
//       <h2 style={{
//         fontSize: '20px',
//         fontWeight: 'bold',
//         color: '#15803d',
//         marginBottom: '1rem',
//         textAlign: 'center',
//       }}>
//         📅 OHM Holiday Calendar - 2025
//       </h2>

//       <div style={{
//         backgroundColor: 'white',
//         padding: '1rem',
//         borderRadius: '1rem',
//         boxShadow: '0 0 10px rgba(0,0,0,0.1)',
//         width: '100%',
//         maxWidth: '400px',
//       }}>
//         <Calendar
//           onChange={setSelectedDate}
//           value={selectedDate}
//           tileContent={tileContent}
//         />
//       </div>

//       <div style={{
//         marginTop: '1.5rem',
//         textAlign: 'center',
//         color: '#15803d',
//         fontWeight: 500,
//         fontSize: '14px',
//       }}>
//         {holiday ? (
//           <div style={{ fontSize: '16px' }}>
//             🎉 <strong>{holiday.name}</strong> <br />
//             falls on <span style={{ fontStyle: 'italic' }}>{format(selectedDate, "eeee, MMM d")}</span>
//           </div>
//         ) : (
//           <div>No holiday on this date</div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default HolidaysListing;
